export const BOSTON_TZ = "America/New_York";

const parse = (v) => {
  if (!v) return null;
  // Date-only values are anchored to Boston noon so the calendar day never shifts for far-away viewers.
  const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(v) ? `${v}T12:00:00${bostonOffset(v)}` : v);
  return Number.isNaN(d.getTime()) ? null : d;
};

const bostonOffset = (ymd) => {
  const probe = new Date(`${ymd}T12:00:00Z`);
  const name = new Intl.DateTimeFormat("en-US", { timeZone: BOSTON_TZ, timeZoneName: "shortOffset" }).formatToParts(probe).find((p) => p.type === "timeZoneName")?.value || "GMT-5";
  const m = name.match(/GMT([+-])(\d{1,2})/);
  return m ? `${m[1]}${m[2].padStart(2, "0")}:00` : "-05:00";
};

const fmt = (v, opts) => { const d = parse(v); return d ? new Intl.DateTimeFormat("en-US", { timeZone: BOSTON_TZ, ...opts }).format(d) : ""; };

// "Jun 12, 2026"
export const fmtDate = (v) => fmt(v, { year: "numeric", month: "short", day: "numeric" });
// "Jun 12, 2026, 7:30 PM"
export const fmtDateTime = (v) => fmt(v, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
// "2026-06-12" in Boston calendar terms (for stored UTC timestamps)
export const toLocalISODate = (v) => { const d = parse(v); return d ? new Intl.DateTimeFormat("en-CA", { timeZone: BOSTON_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(d) : ""; };
export const todayISO = () => toLocalISODate(new Date());
export const monthLabel = (ym) => { if (!ym) return ""; const [y, m] = ym.split("-").map(Number); return new Date(y, m - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" }); };

const fmt12 = (t) => { if (!t) return ""; if (!/^\d{1,2}:\d{2}$/.test(t)) return t; const [h, m] = t.split(":").map(Number); const ap = h >= 12 ? "PM" : "AM"; return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${ap}`; };
export const timeRange = (e) => (e?.time ? ` · ${fmt12(e.time)}${e.end_time ? ` – ${fmt12(e.end_time)}` : ""}` : "");
export const to24h = (t) => {
  if (!t) return "";
  if (/^\d{2}:\d{2}$/.test(t)) return t;
  const m = /^(\d{1,2})(?::(\d{2}))?\s*([ap])\.?m?\.?$/i.exec(t.trim());
  if (!m) return "";
  let h = Number(m[1]) % 12; if (m[3].toLowerCase() === "p") h += 12;
  return `${String(h).padStart(2, "0")}:${m[2] || "00"}`;
};
